<!--
  @author xiehan
  @description 数据查询 详情页
  @date 2018/11/26
-->
<template>
  <div class="checkData__content">
    <g-back :history="history" class="ilb mr-base"></g-back>
    <el-button 
      type="primary" 
      v-text="$t('common.edit')"
      @click="jump2Edit"
      v-g-rac="gRac('checkData@edit')"></el-button>
    <el-form ref="searchForm" :model="searchForm" :inline="true" input-width="auto" v-show="searchList.length !== 0">
      <el-form-item v-for="item in searchList" :label="item.name" :prop="item.property" :key="item.property">
        <el-input v-model="searchForm[item.property]" v-show="item.valueType !== 'LONG'"></el-input>
        <span v-show="item.valueType === 'LONG'">
          <el-date-picker 
            value-format="timestamp" 
            style="width: 180px;" 
            v-model="searchForm[item.property + '_start']" 
            type="datetime">
          </el-date-picker>
          <el-date-picker 
            value-format="timestamp" 
            style="width: 180px;" 
            v-model="searchForm[item.property + '_end']" 
            type="datetime">
          </el-date-picker>
        </span>
      </el-form-item>
      <el-form-item>
        <el-button 
          type="primary" 
          v-text="$t('common.search')"
          @click="search(true)"
          v-g-rac="gRac('checkData@search')"></el-button>
      </el-form-item>
    </el-form>
    <el-table-extend
      :data="tableData"
      :head="tableHead"
      :currentChange="currentChange"
      :sizeChange="sizeChange"
      border>
    </el-table-extend>
  </div>
</template>

<script>
  import rac from '@/plugins/rac-mixin'
  import dataSearchBiz from '@/logic/logRetrieve/dataSearchBiz'
  import TimeFormat from '@/utils/timeFormat'
  export default {
    mixins: [rac],
    data () {
      return {
        history: [],
        currentPage: 1,
        perPageCount: 10,
        tableData: {},
        tableHead: [],
        searchList: [],
        searchForm: {}
      }
    },
    components: {},
    methods: {
      init () {
        this.searchForm = {}
        this.currentPage = 1
        this.perPageCount = 10
        this.getDataInfo()
      },
      setHistory (name) {
        this.history = []
        this.history.push({ name: name })
      },
      jump2Edit () {
        this.$router.push({ name: 'handlerSearchConfig', query: { id: this.$route.query.id } })
      },
      getDataInfo () {
        dataSearchBiz.queryConditionById({ id: this.$route.query.id }).then(data => {
          this.setHistory(data.name)
          this.setTableHead(data.property.filter(item => item.show))
          this.searchList = data.property.filter(item => item.search)
          this.getTableData()
        })
      },
      setTableHead (list) {
        let arr = []
        list.map(item => {
          arr.push({
            key: item.property,
            label: item.name,
            valueType: item.valueType
          })
        })
        this.tableHead = arr
      },
      getTableData (searchObj) {
        dataSearchBiz.queryData({
          id: this.$route.query.id,
          params: { ...searchObj },
          currentPage: this.currentPage,
          perPageCount: this.perPageCount
        }).then(data => {
          if (data.dataList && data.dataList.length > 0) {
            data.dataList.map(item => {
              for (let i in item) {
                let typeObj = this.tableHead.filter(item => item.key === i)[0]
                if (item[i] === true) {
                  item[i] = 'true'
                } else if (item[i] === false) {
                  item[i] = 'false'
                } else if (typeObj && typeObj.valueType === 'LONG') {
                  item[i] = TimeFormat.getFormatTime(item[i])
                }
              }
            })
          }
          this.tableData = data
        })
      },
      search (fromClick = false) {
        let searchObj = {}
        if (fromClick) {
          this.currentPage = 1
          this.perPageCount = 10
        }
        this.searchList.map((item) => {
          if (item.valueType === 'LONG' &&
            (this.searchForm[item.property + '_start'] || this.searchForm[item.property + '_end'])) {
            searchObj[item.property] = [
              this.searchForm[item.property + '_start'],
              this.searchForm[item.property + '_end']
            ]
          } else if (this.searchForm[item.property]) {
            searchObj[item.property] = this.searchForm[item.property]
          }
        })
        this.getTableData(searchObj)
      },
      currentChange (val) {
        this.currentPage = val
        this.search()
      },
      sizeChange (val) {
        this.currentPage = 1
        this.perPageCount = val
        this.search()
      }
    },
    watch: {
      $route (to, from) {
        if (to.name === 'dataSearchCheck' && (from.name === 'dataSearch' || from.name === 'handlerSearchConfig')) this.init()
      }
    },
    mounted () {
      this.init()
    }
  }
</script>

<style scoped>
</style>